import { createContext } from 'react';

export const OxMenuContext = createContext<{ closeParent: () => void }>({
  closeParent: () => {},
});
